import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {ApiQueryParam, ApiService} from "../service/ApiService";
import {RootState} from "./store";
import {documentResultCollectionType, documentResultType} from "../types/Api/DocumentResultType";
import {documentHydrator} from "../models/hydrator/documentHydrator";
import {document} from "../models/document";

export const fetchData = createAsyncThunk('get-document', async(_, thunkAPI): Promise<any> => {
  const state: state = (thunkAPI.getState() as RootState).document;

  if (state.init > 0) {
    return undefined;
  }

  const apiFilters: ApiQueryParam = new ApiQueryParam();

  apiFilters.addFilter({
    field: 'enabled',
    value: '1'
  });

  apiFilters.setCount(-1);
  apiFilters.addSort({
    by: 'position',
    direction: 'ASC'
  });

  const result: documentResultCollectionType =  await ApiService.get('/document', apiFilters) as documentResultCollectionType;

  return {
    paginate: {
      page: result._page,
      pageCount: result._page_count,
      total: result._total_items
    },
    data: result._embedded.documents.map((document: documentResultType) => {
      return documentHydrator.hydrate(document);
    })
  };
})

interface state {
  init: number;
  loading: boolean;
  paginate?: {
    page: number;
    pageCount: number;
    total: number;
  }
  data: document[]
}

const initialState: state = {
  init: 0,
  loading: false,
  paginate: undefined,
  data: []
}

export const documentSlice = createSlice({
  name: "document",
  initialState,
  reducers: {},
  extraReducers: (builder): void => {
    builder.addCase(fetchData.pending, (state) => {
      state.loading = true;
    })
    builder.addCase(fetchData.fulfilled, (state, action) => {
      if (action.payload !== undefined) {
        state.paginate = action.payload.paginate;
        state.data = action.payload.data;
        state.init = Date.now();
      }

      state.loading = false;
    })
    builder.addCase(fetchData.rejected, (state) => {
      state.loading = false;
    })
  }
});

export default documentSlice.reducer;